import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "VisitorAdd"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_field = _resolveComponent("van-field");
  const _component_Improt = _resolveComponent("Improt");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_datePopup = _resolveComponent("datePopup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "预约申请"
  }), _createVNode(_component_van_form, {
    ref: "formRef",
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.modelForm.name = $event),
        required: "",
        clearable: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        name: "name",
        label: "访客姓名",
        placeholder: "请输入访客姓名",
        rules: [{
          required: true,
          message: '访客姓名不能为空'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modelForm.phone = $event),
        required: "",
        clearable: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        type: "tel",
        name: "phone",
        label: "访客电话",
        placeholder: "请输入访客电话",
        rules: [{
          required: true,
          message: '访客电话不能为空'
        }, {
          validator: _ctx.validPhone,
          message: '请输入正确的访客电话'
        }]
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.cardId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.modelForm.cardId = $event),
        required: "",
        clearable: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        type: "text",
        name: "cardId",
        label: "身份证号",
        placeholder: "请输入身份证号",
        rules: [{
          validator: _ctx.validCard,
          message: '请输入正确的身份证号'
        }],
        class: "noShow"
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.beginTime,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.modelForm.beginTime = $event),
        required: "",
        clearable: "",
        readonly: "",
        "is-link": "",
        clickable: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        name: "beginTime",
        label: "开始时间",
        placeholder: "请选择开始时间",
        rules: [{
          required: true,
          message: '开始时间不能为空'
        }],
        onClick: _cache[4] || (_cache[4] = $event => _ctx.handlerClcikTime('beginTime'))
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.endTime,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.modelForm.endTime = $event),
        required: "",
        clearable: "",
        readonly: "",
        "is-link": "",
        clickable: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        name: "endTime",
        label: "结束时间",
        placeholder: "请选择结束时间",
        rules: [{
          required: true,
          message: '结束时间不能为空'
        }],
        onClick: _cache[6] || (_cache[6] = $event => _ctx.handlerClcikTime('endTime'))
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.visitorNum,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.modelForm.visitorNum = $event),
        required: "",
        clearable: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        name: "visitorNum",
        type: "digit",
        label: "来访人数",
        placeholder: "请输入来访人数",
        rules: [{
          required: true,
          message: '来访人数不能为空'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.license,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.modelForm.license = $event),
        clearable: "",
        required: "",
        "label-width": "100px",
        "input-align": "right",
        "error-message-align": "right",
        name: "license",
        label: "车牌号码",
        placeholder: "请输入车牌号码",
        rules: [
        // { required: false, message: '车牌号不能为空' },
        {
          validator: _ctx.valLicense,
          message: '请输入正确的车牌号码'
        }],
        class: "noShow"
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.visitReason,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.modelForm.visitReason = $event),
        border: false,
        class: "visitReason",
        autosize: "",
        clearable: "",
        required: "",
        rows: "2",
        label: "来访事由",
        type: "textarea",
        maxlength: "100",
        placeholder: "请输入来访事由",
        "label-align": "top",
        "show-word-limit": "",
        rules: [{
          required: true,
          message: '来访事由不能为空'
        }]
      }, null, 8, ["modelValue"]), _cache[13] || (_cache[13] = _createElementVNode("div", {
        style: {
          "height": "10px",
          "background-color": "#f8faff"
        }
      }, null, -1)), _createVNode(_component_van_field, {
        modelValue: _ctx.modelForm.photoPath,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.modelForm.photoPath = $event),
        class: "remark",
        border: false,
        required: "",
        "label-align": "top",
        name: "photoPath",
        label: "请上传人脸照片",
        rules: [{
          required: true,
          message: '人脸图片不能为空'
        }]
      }, {
        input: _withCtx(() => [_createVNode(_component_Improt, {
          onChange: _cache[10] || (_cache[10] = url => _ctx.modelForm.photoPath = url)
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_button, {
      class: "submit",
      block: "",
      loading: _ctx.loading,
      "loading-text": "提交中...",
      disabled: _ctx.loading,
      type: "primary",
      "native-type": "submit"
    }, {
      default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 提交 ")])),
      _: 1
    }, 8, ["loading", "disabled"])]),
    _: 1
  }, 8, ["onSubmit"]), _createVNode(_component_datePopup, {
    show: _ctx.showPicker,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => _ctx.showPicker = $event),
    onChange: _ctx.dateChange
  }, null, 8, ["show", "onChange"])]);
}